import React from 'react';
import { Link } from 'react-router-dom';
import { DEVICES_FORMAT_TEST_PATH, UNTESTED_ZONE_BADGE_TEXT } from '../utils/zoneFormatCeiling';

const VERIFIED_LIMIT_STYLE = {
  color: '#C9A84C',
  background: 'rgba(201,168,76,0.12)',
  border: '1px solid rgba(201,168,76,0.25)',
};

const UNTESTED_STYLE = {
  color: 'var(--text-secondary, #6e6e73)',
  background: 'rgba(107, 114, 128, 0.12)',
  border: '1px dashed rgba(107, 114, 128, 0.45)',
  fontWeight: 500,
  textTransform: 'none',
};

/**
 * Zone format ceiling badge — untested default cap uses distinct styling + Devices link.
 */
export default function ZoneFormatCeilingBadge({ kind, label, className = '' }) {
  if (kind === 'untested_default') {
    return (
      <Link
        to={DEVICES_FORMAT_TEST_PATH}
        className={`text-[10px] leading-snug px-2 py-1 rounded inline-flex flex-shrink-0 max-w-full ${className}`.trim()}
        style={UNTESTED_STYLE}
        title={UNTESTED_ZONE_BADGE_TEXT}
        data-zone-format-badge="untested"
      >
        {UNTESTED_ZONE_BADGE_TEXT}
      </Link>
    );
  }

  return (
    <span
      className={`text-[8px] font-bold px-1.5 py-0.5 rounded flex-shrink-0 uppercase whitespace-nowrap ${className}`.trim()}
      style={VERIFIED_LIMIT_STYLE}
      data-zone-format-badge={kind === 'verified_limit' ? 'verified-limit' : 'normal'}
    >
      {label}
    </span>
  );
}
